import React, { Component } from 'react';
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import classNames from 'classnames';
import { confirmAlert } from 'react-confirm-alert'; // Import
import {debounce} from 'lodash';
import {PatientTodaysRecordFrequencyDataListAction,deletePatientTodaysRecordFrequencyDataAction,UpdateCollectedBehaviorData} from '../../actions/BehaviourDataActions';
import { CancelButton } from '../../../../../../../../components/buttons';
import SmallLoader from '../../../../../../../../img/small-loader.gif';
import { showFormatedDateandTime} from '../../../../../../../../actions/utilAction';
import { renderTextField,isInteger } from '../../../../../../../../components/reduxFields';
import { change, Field, reduxForm } from 'redux-form';
import moment from 'moment';

class RecordFrequencyDataViewModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId ? parseInt(props.patientId) : null,
            deleteModal: false,
            creadtedDate: props.creadtedDate
        }
        this.handleValueChange = this.handleValueChange.bind(this);
    }

    componentWillMount = () => {
        this.props.PatientTodaysRecordFrequencyDataListAction(this.state.patientId, this.props.uuid, this.state.creadtedDate)
    }

    componentWillReceiveProps(nextProps) {
        // This is commented because of the two child modals
        // Please ask shubham first before uncommenting this

        // let self = this;
        // document.onkeydown = function (evt) {
        //     evt = evt || window.event;
        //     if (evt.keyCode === 27) {
        //         self.handleClose();
        //     }
        // };

            (nextProps.patientTodaysRecordFrequencyDataList && nextProps.patientTodaysRecordFrequencyDataList.data.PatRecordFrequencyData || []).forEach((obj, index) => {
                this.props.dispatch(change('RecordFrequencyDataViewModalForm', `Behavior[${index}].value`, obj.value || 0));
            });
    }

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    handleValueChange = (event, data, action) => {
        this.props.UpdateCollectedBehaviorData(data.id, data.recordFrequencyDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, event.target.value, 0.0, this.state.patientId, 'VALUE', 'FREQUENCY', this.props.uuid, this.state.creadtedDate)
    }

    deBounceHandleValueChange = debounce(this.handleValueChange,1000)

    handleDeleteClick = (e, Obj) => {
        this.setState({
            deleteModal : true
        })
        
        confirmAlert({
            title: 'Delete Selected Frequency Data',
            message: 'Are you sure you want to delete this Frequency Data?',
            buttons: [
              {
                label: 'Yes',
                onClick: () => {
                    this.props.deletePatientTodaysRecordFrequencyDataAction(Obj.recordFrequencyDataDetailId, this.state.patientId, this.props.uuid, this.state.creadtedDate)
                    this.setState({
                        deleteModal: false
                    })
                }

              },
              {
                label: 'No',
                onClick: () => {
                    this.setState({
                        deleteModal: false
                    })
                }
              }
            ],
            closeOnClickOutside: false, //By Default it is true
            closeOnEscape: false,       //By Default it is true
          });
    }

    renderLoading = () => {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    renderData = (patientTodaysRecordFrequencyDataList) => {
        patientTodaysRecordFrequencyDataList = patientTodaysRecordFrequencyDataList || [];
        if (!patientTodaysRecordFrequencyDataList.length) {
            return (
                <tr>
                    <td colSpan="4">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return patientTodaysRecordFrequencyDataList.map((Obj, index) => {
            return (
                <tr key={index}>
                    <td>{Obj.behaviorCategoryName}</td>
                    <td>{showFormatedDateandTime(Obj.sessionDate)}</td>
                    <td>
                        <Field
                            name={`Behavior[${index}].value`}
                            type="text"
                            maxLength="2"
                            label="Value"
                            component={renderTextField}
                            normalize={isInteger}
                            disabled={ this.props.updatePermissionBehavior ? false: true}
                            onChange={(event) => this.deBounceHandleValueChange(event, Obj, 'VALUE')}
                        />
                    </td>
                    <td>
                        {this.props.deletePermissionBehavior && <button onClick={(e) => this.handleDeleteClick(e, Obj)} title="Delete" type="button" className="tbactionbtn redfont">
                            <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </button>}
                    </td>
                </tr>
            )
        })
    }

    renderPatientRecordABCDataList = () => {
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.condensed,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
        });
        const { patientTodaysRecordFrequencyDataList } = this.props;
        let PatientTodaysRecordFrequencyDataList = (patientTodaysRecordFrequencyDataList && patientTodaysRecordFrequencyDataList.data.PatRecordFrequencyData) || [];
        return (
            <div className="readmin-panel mt-10">
                <div className="panel-body">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="table-responsive mt-15">
                                <table className={tableClass}>
                                    <thead>
                                        <tr>
                                            <th width="30%">Category Name</th>
                                            <th width="30%">Session Date</th>
                                            <th width="30%">Value</th>
                                            <th width="10%">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.renderData(PatientTodaysRecordFrequencyDataList)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const actions = [<CancelButton className="mr-15" onTouchTap={this.handleClose} />];
        return (
            <div>
                {!this.state.deleteModal && <Dialog
                    className="custom_modal"
                    title="Undo Past Data"
                    modal={false}
                    open={this.state.open}
                    actions={actions}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    {this.renderPatientRecordABCDataList()}
                </Dialog>}
            </div>
        )
    }
}
RecordFrequencyDataViewModal = reduxForm({
    form: 'RecordFrequencyDataViewModalForm',
    //enableReinitialize: true,
})(RecordFrequencyDataViewModal);

function mapStateToProps(state) {
    return {
        loading: state.patientBehaviourData.loading,
        patientTodaysRecordFrequencyDataList: state.patientBehaviourData.patientTodaysRecordFrequencyDataList
    }
}

export default connect(mapStateToProps, { PatientTodaysRecordFrequencyDataListAction, deletePatientTodaysRecordFrequencyDataAction,UpdateCollectedBehaviorData })(RecordFrequencyDataViewModal)




// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/componnets/BehaviorData/components/RecordFrequency/RecordFrequencyDataViewModal.js